module.exports = __webpack_public_path__ + "img/全国销售额(元).3d278849.png";